import { Component, OnInit } from "@angular/core";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import { FormField } from "src/app/interfaces/form-field.model";
import { formatDate } from "@angular/common";
import { NotifierService } from "angular-notifier";
import { OutstandingDeliveryService } from "src/app/services/sales-reports/outstanding-delivery";

@Component({
  selector: "app-outstanding-delivery",
  templateUrl: "./outstanding-delivery.component.html",
  styleUrls: ["./outstanding-delivery.component.css"],
})
export class OutstandingDeliveryComponent implements OnInit {
  faPrint = faPrint;
  lockPrint: boolean = true;

  FormFields: FormField[] = [
    {
      type: "date",
      id: "FromDate",
      label: "From Register Date (dd/mm/yyyy)",
      required: true,
    },
    {
      type: "date",
      id: "ToDate",
      label: "To Register Date (dd/mm/yyyy)",
      required: true,
    },
    {
      type: "radio",
      id: "Status",
      label: "Status",
      value: "2",
      options: [
        {
          value: "2",
          display: "Outstanding",
        },
        {
          value: "1",
          display: "Ready",
        },
        {
          value: "3",
          display: "Both",
        },
      ],
    },
    {
      type: "select",
      id: "Format",
      label: "Select format",
      options: [
        { display: "PDF", value: "pdf" },
        { display: "EXCEL", value: "excel" },
        { display: "BOTH", value: "both" },
      ],
      value: "pdf",
    },
  ];
  constructor(
    private notifier: NotifierService,
    private outstandingDeliveryService: OutstandingDeliveryService,
  ) {}

  ngOnInit() {}

  print(): void {
    const FromDate = this.getField("FromDate").value;
    const ToDate = this.getField("ToDate").value;
    const Format = this.getField("Format").value;
    const Id = this.getField("Status").value;

    if (!FromDate || !ToDate) {
      this.notifier.notify(
        "error",
        "Please provide valid date values",
      );
      return;
    }

    const formattedFromDate = formatDate(
      FromDate,
      "dd/MM/yyyy",
      "en-US",
    );
    const formattedToDate = formatDate(ToDate, "dd/MM/yyyy", "en-US");

    this.outstandingDeliveryService
      .OutstandingDeliveryReport(
        Id,
        formattedFromDate,
        formattedToDate,
      )
      .subscribe({
        next: ({ body }) => {
          if (["pdf", "both"].includes(Format)) {
            window.open(body.Name, "_blank");
          }
          if (["excel", "both"].includes(Format)) {
            window.open(body.Value, "_blank");
          }
        },
        error: console.error,
      });
  }

  update(): void {
    this.lockPrint = !(
      this.getField("FromDate").value && this.getField("ToDate").value
    );
  }

  getField(id: string): FormField {
    return (
      this.FormFields.find((f) => f.id === id) || {
        id: "",
        type: "text",
        label: "",
        value: null,
      }
    );
  }
}
